// ----------------------------------------------------------------------------
// Component: Page Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block'; //if using page-hero--video

// Styles
import './_page-hero.scss';
import './_page-hero--content-layout.scss';